import { View, StyleSheet, Text, Image } from "@react-pdf/renderer";
import React from "react";
import { Quotation } from "../../../generated/graphql";

const QuotationSignature: React.FC<{ quotation: Quotation }> = ({
  quotation,
}) => {
  return (
    <View style={styles.container}>
      <View style={[styles.col, { paddingBottom: 14 }]}>
        <View style={[styles.signature, { minWidth: 120 }]}></View>
      </View>
      <View style={[styles.col, { position: "relative" }]}>
        <Image
          src={quotation?.signatureBackground?.imageUrl}
          style={styles.signatureBackgroundImage}
        />
        <Image
          src={quotation?.signature?.imageUrl}
          style={styles.signatureImage}
        />
        <Text style={styles.signature}>{quotation?.signature?.name}</Text>
        <Text style={styles.company}>Gesano Tour & Travel Agency</Text>
      </View>
    </View>
  );
};

// Create styles
const styles = StyleSheet.create({
  container: {
    marginTop: "auto",
    paddingBottom: 26,
    display: "flex",
    flexDirection: "row",
    fontFamily: "Poppins",
    fontSize: 8,
  },
  col: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  signature: {
    borderBottom: "1px solid #192855",
    marginBottom: 2,
  },
  company: { fontWeight: 600, color: "#002a8f" },
  signatureBackgroundImage: {
    width: "auto",
    height: 80,
    top: "50%",
    transform: "translateY(-30%)",
    position: "absolute",
  },
  signatureImage: {
    width: 100,
    height: "auto",
    marginBottom: 1,
  },
});

export default QuotationSignature;
